import styled, { css } from 'styled-components';
import Image from 'next/image';
import { rem } from '~/src/helpers/rem-converter.helper';
import {
    MAX_1919,
    MAX_1679,
    MAX_1365,
    MAX_1279,
    MAX_1023,
    MAX_767,
    MAX_479,
} from '~/src/styles/tokens/break-points';
import { mediaQuery } from '~/src/styles/mixins';
import { FONTS } from '~/src/styles/style-helpers/font-helper';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';
import { COLORS } from '~/src/styles/tokens/colors';
import { Z_INDEX } from '~/src/styles/tokens/z-index';

export const AboutProductBannerContainer = styled.div`
    position: relative;
    width: 100%;
    min-height: ${rem(360)};
    max-height: fit-content;
    flex-direction: column;
    flex-wrap: nowrap;
    border-radius: ${BORDER_RADIUS.biggest20};
    padding: ${rem(52)} ${rem(40)};
    background: ${COLORS.gradientRedPurpleBlue};
    margin: 0 auto;
    max-width: ${rem(1552)};

    ${mediaQuery(
        { maxWidth: MAX_1919 },
        css`
            max-width: ${rem(1599)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            height: fit-content;
            padding: ${rem(360)} ${rem(40)} ${rem(52)};
            border-radius: ${BORDER_RADIUS.zero};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            border-radius: ${BORDER_RADIUS.zero};
            padding: ${rem(296)} ${rem(20)} ${rem(52)};
            height: auto;
        `,
    )};
`;

export const AgencyProductsBannerContent = styled.div`
    display: flex;
    flex-direction: column;
    max-width: ${rem(760)};

    ${mediaQuery(
        { maxWidth: MAX_1679 },
        css`
            max-width: ${rem(638)};
        `,
    )};
	
	${mediaQuery(
        { maxWidth: MAX_1023 },
        css`
            max-width: 100%;
        `,
    )};
`;

export const AboutProductBannerTitle = styled.h1`
    max-width: ${rem(497)};
    margin-bottom: ${rem(16)};
    text-transform: uppercase;
    ${FONTS.wide.medium.size72};
    color: ${COLORS.textPrimaryDark};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            max-width: 100%;
            ${FONTS.wide.medium.size44};
        `,
    )};
`;

export const BottomContainer = styled.div`
    width: 100%;
    gap: ${rem(20)};
    flex-direction: column;
    flex-grow: 1;
    justify-content: flex-end;

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            max-width: 100%;
        `,
    )};
`;

export const SubText = styled.span`
    ${FONTS.compact.regular.size20};
    line-height: ${rem(28)};
    color: ${COLORS.textLightInverted};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            ${FONTS.compact.regular.size17};
            line-height: ${rem(24)};
        `,
    )};
`;

export const BannerBgImage = styled(Image)`
    position: absolute;
    right: ${rem(40)};
    bottom: 0;

    ${mediaQuery(
        { maxWidth: MAX_1679 },
        css`
            height: 100%;
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1365 },
        css`
            right: ${rem(28)};
        `,
    )};
`;

export const BannerBookImage = styled(Image)`
    position: absolute;
    right: ${rem(80)};
    bottom: ${rem(20)};
    z-index: ${Z_INDEX.level1};

    ${mediaQuery(
        { maxWidth: MAX_1365 },
        css`
            right: ${rem(28)};
            bottom: ${rem(32)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            left: 0;
            right: 0;
            margin: 0 auto;
            top: ${rem(36)};
            width: ${rem(310)};
            height: fit-content;
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            top: ${rem(8)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_479 },
        css`
            top: ${rem(26)};
            width: ${rem(254)};
            height: fit-content;
        `,
    )};
`;
